import { defineComponent as _defineComponent } from 'vue'
import { useRouter } from 'vue-router/composables'
import { mdiLeadPencil } from '@mdi/js'
import { type TCreateEventFormKey } from '@/pages/CreateEventProcessingPage/static'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventTotalSection',
  props: {
    step: null,
    title: null,
    eventId: null
  },
  setup(__props: any) {

const props = __props as {
  step: TCreateEventFormKey
  title?: string
  eventId: number
};



const router = useRouter()

function handleClickEdit() {
  router.push({
    name: 'EventEdit',
    query: { step: props.step },
    params: { id: String(props.eventId) },
  })
}

return { __sfc: true,props, router, handleClickEdit, mdiLeadPencil }
}

})